import { useEffect } from "react";
import HeaderImg from "../components/HeaderImg";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <HeaderImg title="Privacy Policy" />
      <div className="legal">
        <div className="legal__container">
          <p className="legal__intro">
            <strong>CHAOL CARINGTON Ltd</strong> is committed to protecting your
            personal data. We comply with the{" "}
            <strong>Nigeria Data Protection Regulation (NDPR)</strong>.
          </p>

          <div className="legal__section">
            <h2 className="legal__section__title">1. Data We Collect</h2>
            <ul className="legal__list">
              <li>
                <strong>From enrolment/purchases:</strong> name, phone, email,
                address, ID copies, and training records.
              </li>
              <li>
                <strong>From website use:</strong> IP address and browser
                information (via cookies for basic functionality).
              </li>
            </ul>
          </div>

          <div className="legal__section">
            <h2 className="legal__section__title">2. How We Use Your Data</h2>
            <ul className="legal__list">
              <li>
                Process enrolments, deliver training, fulfil orders, and provide
                repair/support services.
              </li>
              <li>
                Send updates, receipts, certificates, and promotions. You may
                opt out at any time.
              </li>
              <li>Comply with applicable legal requirements.</li>
            </ul>
          </div>

          <div className="legal__section">
            <h2 className="legal__section__title">3. Data Sharing</h2>
            <p className="legal__text">
              We <strong>do not sell</strong> your personal data. We share
              limited data only with:
            </p>
            <ul className="legal__list">
              <li>Delivery partners (for equipment orders).</li>
              <li>Authorities, if required by law.</li>
            </ul>
          </div>

          <div className="legal__section">
            <h2 className="legal__section__title">4. Your Rights (NDPR)</h2>
            <p className="legal__text">
              You have the right to request access, correction, deletion, or
              opt-out of your data at any time. Email us at{" "}
              <a href="mailto:chaolcarington1@gmail.com">
                chaolcarington1@gmail.com
              </a>
              . We respond within <strong>30 days</strong>.
            </p>
          </div>

          <div className="legal__section">
            <h2 className="legal__section__title">5. Security</h2>
            <p className="legal__text">
              We use reasonable safeguards including secure storage and limited
              access controls. However, no system is 100% secure.
            </p>
          </div>

          <div className="legal__section">
            <h2 className="legal__section__title">6. Cookies</h2>
            <p className="legal__text">
              We use basic cookies for site functionality only. You can manage
              or disable cookies in your browser settings.
            </p>
          </div>

          <div className="legal__section">
            <h2 className="legal__section__title">7. Changes to This Policy</h2>
            <p className="legal__text">
              Policy updates will be posted on this page. Continued use of our
              services means acceptance of the updated policy.
            </p>
          </div>

          <div className="legal__contact">
            <h3>Contact Us</h3>
            <p>
              Email:{" "}
              <a href="mailto:chaolcarington1@gmail.com">
                chaolcarington1@gmail.com
              </a>
            </p>
            <p>WhatsApp: +234 704 141 0503</p>
            <p>Phone: 08133374900 | 090520772322 </p>
            <p>
              Address: No. 22, 14 Road, Corner Shop, Gwarinpa Estate, Abuja,
              Nigeria.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
